import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class DrainHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = false;
    this.type = "drain";

    this.build();
  }

  build() {
    super.build();

    this.testedTile = new PIXI.Sprite(app.game.assets["tile-trou-drainage"]);
    this.testedTile.texture.source.resource.loop = true;
    this.testedTile.texture.source.resource.pause();
    this.testedTile.texture.source.resource.currentTime = 0;
    this.testedTile.position.set(-49, -55);
    this.testedTile.alpha = 0;

    this.addChild(this.testedTile);
  }

  test() {
    // There's nothing to test as we can see the hole already
    app.audio.play(app.data.global.sounds.blocked_tile, 1.0, true);
  }

  hit() {
    setTimeout(() => {
      app.audio.play(app.data.global.sounds.obstacle, 1.0, true);
      app.audio.play(app.data.global.sounds.splash_water, 1.0, true);
    }, app.game.player.playerMovementDuration);
  }

  show() {
    this.shown = true;
    this.testedTile.texture.source.resource.play();

    gsap.to(this.testedTile, {
      pixi: {
        alpha: 1
      },
      duration: 0.5,
      ease: "power1.inOut",
    })
  }

  endOfTurnAction() {
    // To be overwritten in child if needed
    if (!this.shown && this.isLessThanTwoCellsFromPlayer()) {
      this.show();
    }
  }

  endGame() {
    app.game.endGame();
    app.animateOutGame(6);
  }

  // Reset the states so we can animate in again and start over
  reset() {
    // this.testedTile.alpha = 0;
  }


}
